function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 2,
  rx: 0.5,
  fill: "#4F4F4F"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 6,
  width: 20,
  height: 2,
  rx: 0.5,
  fill: "#4F4F4F"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 12,
  width: 20,
  height: 2,
  rx: 0.5,
  fill: "#4F4F4F"
});

function SvgNavMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 14",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgNavMenu;